import { render, staticRenderFns } from "./ProductKey.vue?vue&type=template&id=541aade0&scoped=true"
import script from "./ProductKey.vue?vue&type=script&lang=js"
export * from "./ProductKey.vue?vue&type=script&lang=js"
import style0 from "./ProductKey.vue?vue&type=style&index=0&id=541aade0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541aade0",
  null
  
)

export default component.exports